import { all, call, put, takeEvery, select } from 'redux-saga/effects'
import { actions as followUpPromptsActions } from './FollowUpPromptsSlice'
import { getLanguageCode } from '../translation/TranslationSelector'

function* followUpPromptsRequest(services, { payload }) {
  const DougallService = services('DougallService')
  const SessionService = services('SessionService')

  try {
    const siteId = parseInt(process.env.REACT_APP_PHNX_SITEID_V2)
    const userLanguage = yield select(getLanguageCode())
    const [languageCode] = userLanguage.split('-')
    const deviceId = yield call(
      [SessionService, 'getCookie'],
      'V2_PSL_DEVICE_ID'
    )

    const { result } = yield call([DougallService, 'followUpPromptsRequest'], {
      ...payload,
      deviceId,
      siteId,
      type: 'followup',
      languageCode
    })
    const { followUpPrompts } = result
    yield put(
      followUpPromptsActions.requestSuccess({ prompts: followUpPrompts })
    )
  } catch (e) {
    console.error('Error in followUpPromptsRequest:', e)
    yield put(followUpPromptsActions.requestFail())
  }
}

export default function* watchFollowUpPrompts(services) {
  yield all([
    takeEvery(
      followUpPromptsActions.requestPrompts,
      followUpPromptsRequest,
      services
    )
  ])
}
